import React, {useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Form,
  Table,
  Input,
  Button,
  InputGroup,
  Label,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { Grid } from '@mui/material';
import styles from "./Contacts.module.scss"


// Redux
import { connect, useDispatch,useSelector} from "react-redux";
import { withRouter, Link, useHistory} from "react-router-dom";


//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Pagination from "./components/PaginationContact"
import Loader from "../../components/Common/Loader";

//Action
import { contactsList } from "../../store/contacts/actions";
import { contactsFilter } from "../../store/contacts/actions";
import { contactsDelete} from "../../store/contacts/actions";
import { grupotecnicoList } from "../../store/grupoTecnico/actions";



const ContactsList = (props) => {
const dispatch= useDispatch();
const history= useHistory();
const user = JSON.parse(localStorage.getItem("user"))
const groups =String(user.groups);
const user_permissions = String(user.user_permissions)

const [checked, setchecked] = useState(false);


useEffect(() => {
  // Obtener el valor almacenado en el Local Storage al cargar el componente
  const storedChecked = localStorage.getItem('checked');
  if (storedChecked) {
    setchecked(JSON.parse(storedChecked));
  }
}, []);

useEffect(() => {
  // Guardar el valor en el Local Storage cada vez que cambie
  localStorage.setItem('checked', JSON.stringify(checked));
}, [checked]);



const changeLista = (e) => {
  setchecked(e.target.checked)
}

const [search, setSearch] = useState("");

const onChange = (e) => {
  setSearch(e.target.value);
};

const onSubmit = (e) => {
  e.preventDefault();
  dispatch(contactsFilter(`?search=${search}`));
};

const resetSearch = () => {
  dispatch(contactsFilter(`?search=`));
  setSearch("");
};


useEffect(() => {

  dispatch(contactsList());
  dispatch(grupotecnicoList())
},[dispatch]);


const grupotTecnico = useSelector(state => state.GrupoTecnico.grupotecnico.results) || []

const handleShow = (id) =>{ 
  history.push(`/contact/${id}/contact_profile`);
  }

const params = {
  count: props.contacts.count,
  next: props.contacts.next,
  previous: props.contacts.previous,
  results: props.contacts.results,

};
let  netxEstado =params.next && params.next.substring(params.next.indexOf("?contactType=") + 13, params.next.indexOf("&limit"));
let prevEstado = params.previous && params.previous.substring(params.previous.indexOf("?contactType=") + 13, params.previous.indexOf("&limit"));
console.log()

let paramsEstado = netxEstado !==null ? netxEstado : prevEstado

const handleParamsEstadoChange = (estado) => {
  // Aquí puedes realizar cualquier acción necesaria con el nuevo valor de props.paramsEstado
   console.log('Nuevo valor de props.paramsEstado:', estado);
  
  paramsEstado = estado

}

const [confirmText, setConfirmText] = useState(false);
const [confirmDel, setConfirmDel] = useState("");
const [cancel, setCancel]= useState(false)



const handleConfirm =(id) => {
  setConfirmText(true)
  setConfirmDel(id)
}





const reload = () => {
  window.location.reload()
}

  return (
    <React.Fragment>

      
{confirmText ? (
              <SweetAlert
                title="¿Estás seguro de que quieres eliminar este Contacto ?"
                warning
                showCancel
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => {
                 dispatch(contactsDelete(confirmDel))
                 setConfirmText(false)
                  }}
                onCancel={() => {
                    setConfirmText(false)
                    setCancel(true)

                }}
            >
            </SweetAlert>
          ) : null}
                           
              {cancel ? (
              <SweetAlert
                title="Cancelado"
                warning
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => {setCancel(false)}}
            >
                La información de contacto esta a salvo
            </SweetAlert>
          ) : null} 



{props.contactsDeleted === true ? (
                <SweetAlert
                  title= "Hecho!"
                  success
                  timeout={1000}
                  showConfirm={false}
                  onConfirm={() => {
                    setConfirmText(false);
                    reload();
                           
                  }}
                >
                  Se ha eliminado el contacto con éxito!
                </SweetAlert>
              ) : null}
    <div className="page-content">
      <MetaTags>
        <title>tccontrol | Contactos</title>
      </MetaTags>
      <Container fluid>
        {/* Render Breadcrumb */}
        <Breadcrumb title={"tccontrol"} breadcrumbItem={"Contactos"} />
        {props.loading ? (
          <Loader />
        ) : (
          <div>                   
            {/* Card Del boton y filtro */}
            <Card >
              <CardBody>
                <Row>
                  <Col md={7}>
                  {groups.includes("SuperAdmin") ||  groups.includes("Supervisor") || groups.includes("Operador") || groups.includes("Crear y modificar Cliente")   || user_permissions.includes('Can add Contact')?(
                    <>
                    <Link
                      className="btn btn-primary waves-effect waves-light"
                      to="/contact/add_contact"
                    >
                      Agregar Contacto{" "}
                      <span className="bx bx-user-plus fa-lg align-middle"></span>
                    </Link>

                  
                    </>
                    


                  ):null}
                  </Col>
                  <Col md={5}>
                    <Form
                      className="search-box"
                      onSubmit={onSubmit}
                    >

                      <InputGroup>
                        <Input
                          type="text"
                          className="form-control"
                          name="search"
                          placeholder="Buscar"
                          value={search}
                          onChange={onChange}
                          
                        />
                        <i className="bx bx-search-alt search-icon" />
                        <Button color="primary" onClick={resetSearch}>
                          <span className=" bx bx-x fa-lg align-middle"></span>
                        </Button>
                      </InputGroup>
                    </Form>
                  </Col>
                </Row>
              </CardBody>
            </Card>


        <Pagination
         paramsEstado={paramsEstado}
          count={params.count}
          next={params.next}
          previous={params.previous}
          limit={10}
          baseUrl="contacto/contacto/"
          filterFunction={contactsFilter}
          handleParamsEstadoChange={handleParamsEstadoChange}
        />

{props.contacts.results ? (
  
<Row className='mt-2 mb-2'>
                      <Col md={12}  className={`${styles.buttonsEstado}`} >

                      <button
                           style={{"backgroundColor":"#00CCCC", "color":"white"}}
                          className="btn btn-lg  mx-2"
                          onClick={() => dispatch(contactsList())}
                        >
                          TODOS <span
                          
                          className="badge bg-danger rounded-pill "
                          style={{"fontSize": "15px"}}
                          > {props.contacts.results.contadorTODOS}</span>

                          </button>

                              
                    <button
                          style={{"backgroundColor":"#FFCC00", "color":"white"}}
                          className="btn btn-lg  mx-2"
                          onClick={ () => dispatch(contactsFilter(`?contactType=PERSONA JURIDICA`))}        
                        >
                          PERSONA JURIDICA <span
                          
                          className="badge bg-danger rounded-pill "
                          style={{"fontSize": "15px"}}
                          > {props.contacts.results.contadorPersonaJuridica}</span>
                        
                      </button>

                      <button
                          style={{ "color":"white"}}
                          className="btn btn-lg bg-warning  waves-effect waves-light mx-2"
                          onClick={ () => dispatch(contactsFilter(`?contactType=PERSONA NATURAL`))}    
                        >
                          PERSONA NATURAL  <span
                          
                          className="badge bg-danger rounded-pill "
                          style={{"fontSize": "15px"}}
                          > {props.contacts.results.contadorPersonaNatural}</span>
                        
                      </button>
                          </Col>
                          </Row>
):null}
            <Card>
                    <div className="form-check form-switch mb-3">
                        <input className="form-check-input mt-3 mx-1" type="checkbox" id="flexSwitchCheckChecked" onChange={changeLista} checked = {checked} />
                        <Label className="form-check-label mt-3 " for="flexSwitchCheckChecked">Ver en Lista</Label>
                    </div>


            {params.count !== 0 ? (
                <CardBody className="pb-0">
                  <h4 className="card-title">Contacto</h4>
                  {checked && ( 
                  <div className="table-responsive">
                    <Table
                      className="table table-bordered table-striped mb-3 text-left"
                      hover
                    >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Documento</th>
                          <th>Nombre del Contacto</th>
                          <th>Tipo de Contacto</th>
                          <th>Acción</th>
                          <th>Grupo de Tecnico</th>
                        </tr>
                      </thead>
                      <tbody>
                          {params.results && Array.isArray(params.results.data) ?
                            params.results.data.map((contacts, idx) => (
                              <tr key={idx}>
                                <th scope="row">{idx}</th>
                                <td>{contacts.documentNumber}</td>
                                <td >{contacts.get_full_name === " " ? contacts.razon_social : contacts.get_full_name}</td>                                
                                <td>{contacts.contactType}</td>
                                
                                <td>

                                <Link 
                                  to = "#"
                                  onClick={()=> handleConfirm(contacts.id)}
                                >                                 
                                  <span className="fa fa-trash fa-lg align-middle m-2"></span>
                                </Link>

                                
                                  
                                  <Link to ={`/contact/${contacts.id}/contact_profile`}                           
                                  >
                                    <span className=" fas fa-eye fa-lg "></span>
                                  </Link>
                                </td>
                                <td>

                                {grupotTecnico.map(item => {
                                      if (item.id === contacts.grupo_tecnico) {
                                        return (item.nombre);
                                      } else {
                                        return "";
                                      }
                                    })}
                                </td>

                              </tr>
                            )):[]} 
                        </tbody>
                      
                    </Table>


                  </div>
                  )}
                
                  {!checked && (
              
              <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} className='p-5 pt-2'>
                
                {params.results && Array.isArray(params.results.data) ? params.results.data.map((contacts,idx) => ( 
                  

                      <Grid  item   md={4} key ={idx} >    
                        <div className = {`${styles.card}`} onClick={() => handleShow(contacts.id)} >

                            <div className={`${styles['card-details']}`}>                            
                                <h3 className="text-primary">{contacts.get_full_name === " " ? contacts.razon_social : contacts.get_full_name}</h3> 
                                <div className="text-primary mt-3 "><strong> Documento</strong></div> 
                                <div>{contacts.documentNumber}</div>      
                                <div className="text-primary mb-6"><strong>Tipo de Contacto</strong> </div>
                                <div>{contacts.contactType}</div>
                                <div>                                  
                                  
                                </div>  
                            </div>  
                        </div>                
                      </Grid>
                  )):[]}
                  </Grid>
                  )}


                </CardBody>
          ) : ( 
                <CardBody>
                  <h4 className="card-title">No se encontraron resultados</h4>
                </CardBody>
          )}

            </Card>


            
          {/* <Pagination
            count={params.count}
            next={params.next}
            previous={params.previous}
            limit={10}
            baseUrl="contacto/contacto/"
            filterFunction={contactsFilter}
          /> */}
          </div>
        )}
      </Container>

    </div>
  </React.Fragment>
);
};
const mapStateToProps = (state) => {
  const { error, loading, contacts , contactsDeleted} = state.Contacts;
  return { error, loading, contacts , contactsDeleted};
};

export default withRouter(connect(mapStateToProps)(ContactsList));